import { IOrganization } from "./IOrganization";
import { IType } from "./ITypes";
import { delay } from "../../utils";
import { IAuditLog, ISubscription, ISubscriptions } from ".";

const DemoDataDelay = 1000;

function parseDemoData<T>(data: string | undefined): T[] {
    const strData = data as string;
    try {
        return strData ? JSON.parse(strData) as T[] : [];
    }
    catch (e) {
        return [];
    }
}

const demo_contacts = parseDemoData<IType>(process.env.REACT_APP_DEMO_CONTACTS);
const demo_customers = parseDemoData<IType>(process.env.REACT_APP_DEMO_CUSTOMERS);
const demo_partners = parseDemoData<IType>(process.env.REACT_APP_DEMO_PARTNERS);
const demo_organization = () => {
    const data = parseDemoData<IOrganization>(process.env.REACT_APP_DEMO_ORGANIZATION);
    const out = [];

    for (let i = 0; i < 20; i++) {
        for (let j = 0; j < data.length; j++)
            out.push(data[j]);
    }
    return out;
}

export const DemoData = {

    enabled: process.env.REACT_APP_USE_DEMO_DATA == "true",

    organizations: demo_organization(),
    contacts: demo_contacts,
    customers: demo_customers,
    partners: demo_partners,

    findOrganizationIndex: (id: string): number => {
        return DemoData.organizations.findIndex((item: IOrganization) => item.Id === id);
    },

    findOrganization: (id: string): IOrganization | undefined => {
        return DemoData.organizations.find((item: IOrganization) => item.Id === id);
    },

    findSubscription: (id: string, body: ISubscription): { subscriptions: ISubscriptions, index: number } => {
        const orgIndex = DemoData.findOrganizationIndex(body.OrganizationId);
        if (orgIndex >= 0) {
            const subscriptions = DemoData.organizations[orgIndex]?.Subscriptions;
            if (subscriptions) {
                const index = subscriptions.findIndex((item: ISubscription | null) => item && item.Id === id);
                return { subscriptions, index };
            }
        }
        throw new Error(`Subscription ID='${id}' do not exists.`);
    },

    getOrganization: async (id: string): Promise<IOrganization> => {
        await delay(DemoDataDelay);
        return new Promise<any>(resolve => {
            resolve(DemoData.findOrganization(id));
        })
    },

    putOrganization: async (id: string, body: IOrganization) => {
        const index = DemoData.findOrganizationIndex(id);
        if (index >= 0) {
            DemoData.organizations[index] = body;
        } else {
            throw new Error(`Organization ID='${id}' do not exists.`);
        }
    },

    getSubscription: (id: string): any => {
        let ret: any = null;
        DemoData.organizations.find((obj: any) => {
            if (obj.Subscriptions) {
                for (let i = 0; i < obj.Subscriptions.length; i++)
                    if (obj.Subscriptions[i].Id === id) {
                        ret = obj.Subscriptions[i];
                        return true;
                    }
            }
            return false;
        });
        return ret;
    },

    putSubscription: async (id: string, body: ISubscription) => {
        const { subscriptions, index } = DemoData.findSubscription(id, body);
        if (subscriptions && index >= 0)
            subscriptions[index] = body;
        else
            throw new Error(`Subscription ID='${id}' do not exists.`);
    },

    deleteSubscription: async (id: string, body: ISubscription) => {
        const { subscriptions, index } = DemoData.findSubscription(id, body);
        if (subscriptions && index >= 0)
            subscriptions[index] === null;
        else
            throw new Error(`Subscription ID='${id}' do not exists.`);
    },

    organizationAuditLogs: (id: string): IAuditLog[] => {
        const org = DemoData.findOrganization(id);
        if (org && org.AuditComment) {
            return [{ Id: org.Id, CreatedOn: org.CreatedOn, Action: "UPDATE", ObjectName: "Organization", Comment: org.AuditComment, Author: "" }]
        }
        return [];
    },

    subscriptionAuditLogs: (id: string): IAuditLog[] => {
        let sub: ISubscription | null | undefined;
        DemoData.organizations.find((item: IOrganization) => {
            const subscriptions = item?.Subscriptions;
            if (subscriptions) {
                sub = subscriptions.find((item: ISubscription | null) => item && item.Id === id);
            }
            return sub;
        });

        if (sub) {
            return [{ Id: sub.Id, CreatedOn: sub.CreatedOn, Action: "UPDATE", ObjectName: "Subscription", Comment: sub.AuditComment || '', Author: "" }]
        }
        return [];
    },
}
